var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRegisterOutputCashTransaction = function SvgRegisterOutputCashTransaction(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.51432 17H5.14673C4.7916 17 4.46311 17.1883 4.28371 17.4948L2.2319 21H29.7681L27.7163 17.4948C27.5369 17.1883 27.2084 17 26.8533 17H24.4857C24.9929 16.3858 25.4348 15.7156 25.8006 15H26.8533C27.9187 15 28.9041 15.565 29.4423 16.4845L31.589 20.1518C31.8582 20.6115 32 21.1346 32 21.6673V28C32 29.6569 30.6569 31 29 31H3C1.34315 31 0 29.6569 0 28V21.6673C0 21.1346 0.141844 20.6115 0.410955 20.1518L2.55768 16.4845C3.09589 15.565 4.08135 15 5.14673 15H6.19942C6.56521 15.7156 7.00707 16.3858 7.51432 17ZM27.5 24C26.6716 24 26 24.6716 26 25.5C26 26.3284 26.6716 27 27.5 27C28.3284 27 29 26.3284 29 25.5C29 24.6716 28.3284 24 27.5 24Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 9.99998C25 14.9705 20.9706 19 16 19C11.0294 19 7 14.9705 7 9.99998C7 5.02943 11.0294 1 16 1C20.9706 1 25 5.02943 25 9.99998ZM21 9C21.5523 9 22 9.44772 22 10C22 10.5523 21.5523 11 21 11H11C10.4477 11 10 10.5523 10 10C10 9.44771 10.4477 9 11 9L21 9Z",
    fill: "currentColor"
  })));
};
export default SvgRegisterOutputCashTransaction;